import { ObjectValueType } from '@shared/utils/type.utils';
export const BrandType = {
  Cp: 'cp',
  Other: 'other'
} as const;
export type BrandType = ObjectValueType<typeof BrandType>;